<template>
  <Sources />
</template>

<script lang="ts">
import Vue from 'vue';
import Sources from '../components/Sources.vue';

export default Vue.extend({
    components: {
        Sources,
    },
});
</script>
